import { reducer as questionnaires } from "@teamprevent/common/questionnaires/reducer";
import { reducer as messages } from "@teamprevent/common/messaging/index";
import { ReducersMapObject } from "redux";
import { MessageState } from "@teamprevent/common/messaging/models";

import { reducer as calendar, calendarFiltersReducer as calendarFilters } from "./calendar";
import { reducer as clinic } from "./calendar/clinics";
import { reducer as clinicTypes } from "./calendar/clinics/clinicTypes";
import { reducer as clinicLocationTypes } from "./calendar/clinics/clinicLocationTypes";
import { reducer as currentUser } from "./auth";
import { TaskCodeState, reducer as taskCodes } from "./crud/taskCode";
import { TextSnippetState, reducer as textSnippets } from "./crud/textSnippet";
import { reducer as customers } from "./crud/customer";
import { reducer as adminUsers } from "./crud/adminUser";
import { reducer as employeeRecordsDetail } from "./crud/employeeRecord";
import { reducer as orgStructures } from "./crud/orgStructure";
import { orgStructureReducer as orgStructure } from "./crud/orgStructure/reducer";
import { CustomerUserState, reducer as customerUsers } from "./crud/customerUser";
import { OrgStructuresReducerDropDownOne } from "./crud/employeeRecord/OrgStructuresReducerDropDown";
import { OrgStructuresReducerDropDownTwo } from "./crud/employeeRecord/OrgStructuresReducerDropDown";
import { OrgStructuresReducerDropDownThree } from "./crud/employeeRecord/OrgStructuresReducerDropDown";
import { OrgStructuresReducerDropDownFour } from "./crud/employeeRecord/OrgStructuresReducerDropDown";
import { reducer as workGroups } from "./crud/workGroup";
import {
    partiallyMatchedEmployeesReducer as partiallyMatchedEmployees
} from "./partiallyMatchedEmployees";
import { reducer as ohCases } from "./crud/ohCase";
import { triages, triage, referralTriageTasks, ppqTriageTasks, physiotherapyReferralTriageTasks, genericCaseTriageTasks } from "./triage/reducer";
import { reducer as bookAppointments } from "./bookAppointments";
import { taskReducer as tasks } from "./tasks/reducer";
import { CustomerDocumentState, reducer as customerDocuments } from "./crud/customerDocument";
import { reducer as teams } from "./teams";
import { reducer as rooms } from "./crud/room";
import { consultationDetails } from "./consultations/reducer";
import { reducer as actionableTasks } from "./actionableTasks";
import { reducer as ppqReports } from "./ppqReport";
import { reducer as immunisationTypes } from "./crud/immunisationType";
import { reducer as customerCategories } from "./crud/customerCategories";
import { reducer as immunisationTypeTasks } from "./crud/immunisationTypeTask";
import { reducer as immunisations } from "./immunisations";
import { reducer as customMedicalTypes } from "./customMedicalTypes";
import { bbvReportSuccessorTasks } from "./bbvReport/reducer";
import { reducer as taskCategories } from "./taskCategories";
import { reducer as dataExtracts } from "./dataExtracts";
import { reducer as questionnaireConfig } from "./questionnaireConfig";
import { reducer as healthSurveillance } from "./healthSurveillance";
import { reducer as sraCustomers } from "./crud/sraCustomer";
import { reducer as sraDepartments } from "./crud/sraDepartment";
import { reducer as sraCustomerUsers } from "./crud/sraCustomerUser";
import { reducer as referralForm } from "./ppq/referralFormReducer";
import { reducer as statistics } from "./statistics";
import { reducer as customerSraDepartments } from "./crud/customerSraDepartment";
import { genericCaseTypes } from "./genericCaseTypes/reducer";
import { sncRules } from "./sncRules/reducer";
import { sraResults } from "./crud/customerUser/reducer";
import { reducer as adminUsersWithTeams } from "./crud/adminUserWithTeams";
import { ApplicationState } from "./applicationState";
import { PartiallyMatchedEmployeeState } from "./partiallyMatchedEmployees/common/model";

export const reducers: ReducersMapObject<
    Omit<ApplicationState, "loading" | "router">
    & TaskCodeState
    & CustomerUserState
    & Omit<PartiallyMatchedEmployeeState, "loading">
    & CustomerDocumentState
    & TextSnippetState
    & MessageState
    & {
        OrgStructuresReducerDropDownOne: any;
        OrgStructuresReducerDropDownTwo: any;
        OrgStructuresReducerDropDownThree: any;
        OrgStructuresReducerDropDownFour: any;
    },
    any
> = {
    bookAppointments,
    calendar,
    calendarFilters,
    clinic,
    clinicTypes,
    clinicLocationTypes,
    currentUser,
    questionnaires,
    taskCodes,
    customerSraDepartments,
    genericCaseTypes,
    sncRules,
    customers,
    adminUsers,
    employeeRecordsDetail,
    orgStructures,
    orgStructure,
    customerUsers,
    OrgStructuresReducerDropDownOne,
    OrgStructuresReducerDropDownTwo,
    OrgStructuresReducerDropDownThree,
    OrgStructuresReducerDropDownFour,
    partiallyMatchedEmployees,
    ohCases,
    triages,
    triage,
    referralTriageTasks,
    ppqTriageTasks,
    physiotherapyReferralTriageTasks,
    genericCaseTriageTasks,
    tasks,
    customerDocuments,
    teams,
    rooms,
    consultationDetails,
    actionableTasks,
    textSnippets,
    ppqReports,
    immunisationTypes,
    customerCategories,
    immunisationTypeTasks,
    immunisations,
    bbvReportSuccessorTasks,
    taskCategories,
    dataExtracts,
    questionnaireConfig,
    workGroups,
    healthSurveillance,
    sraCustomers,
    sraDepartments,
    sraCustomerUsers,
    referralForm,
    statistics,
    messages,
    sraResults,
    adminUsersWithTeams,
    customMedicalTypes
};
